// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-filter {
  padding: 8px;
  min-width: 250px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--color-white);
}

/* Search input */
.filter-search {
  width: 100%;
}

.filter-search-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.filter-search-input:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

/* Actions (Select All) */
.filter-actions {
  border-bottom: 1px solid #eee;
  padding-bottom: 6px;
}

/* Options list */
.filter-options-list {
  max-height: 250px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-options-list::-webkit-scrollbar {
  width: 8px;
}

.filter-options-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.filter-options-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.filter-options-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Checkbox items */
.filter-checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin: 0;
}

.filter-checkbox-item:hover {
  background-color: #f5f5f5;
}

.filter-checkbox-item input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0;
}

.filter-checkbox-label {
  flex: 1 1;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
  color: #333;
}

/* No results message */
.filter-no-results {
  padding: 12px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
}

/* Footer with Apply/Reset Buttons */
.filter-footer-buttons {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
}

.filter-reset-btn,
.filter-apply-btn {
  flex: 1 1;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.filter-reset-btn {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid var(--color-border-light);
}

.filter-reset-btn:hover {
  background-color: #e0e0e0;
}

.filter-reset-btn:active {
  background-color: #d0d0d0;
}

.filter-apply-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
}

.filter-apply-btn:hover {
  background-color:var(--color-primary-green);
}

.filter-apply-btn:active {
  background-color: var(--color-primary-green);
}

/* Dependency notice for DependentCustomSelectFilter */
.filter-dependency-notice {
  font-size: 11px;
  color: #666;
  padding: 4px 8px;
  background-color: #f0f8ff;
  border-left: 3px solid #007bff;
  border-radius: 3px;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/CustomSelectFilter.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".custom-select-filter {\r\n  padding: 8px;\r\n  min-width: 250px;\r\n  max-width: 300px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  background-color: var(--color-white);\r\n}\r\n\r\n/* Search input */\r\n.filter-search {\r\n  width: 100%;\r\n}\r\n\r\n.filter-search-input {\r\n  width: 100%;\r\n  padding: 6px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.filter-search-input:focus {\r\n  outline: none;\r\n  border-color: #4CAF50;\r\n  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);\r\n}\r\n\r\n/* Actions (Select All) */\r\n.filter-actions {\r\n  border-bottom: 1px solid #eee;\r\n  padding-bottom: 6px;\r\n}\r\n\r\n/* Options list */\r\n.filter-options-list {\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.filter-options-list::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.filter-options-list::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.filter-options-list::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 4px;\r\n}\r\n\r\n.filter-options-list::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* Checkbox items */\r\n.filter-checkbox-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n  margin: 0;\r\n}\r\n\r\n.filter-checkbox-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.filter-checkbox-item input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 0;\r\n}\r\n\r\n.filter-checkbox-label {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  user-select: none;\r\n  color: #333;\r\n}\r\n\r\n/* No results message */\r\n.filter-no-results {\r\n  padding: 12px;\r\n  text-align: center;\r\n  color: #999;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n/* Footer with Apply/Reset Buttons */\r\n.filter-footer-buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid #eee;\r\n}\r\n\r\n.filter-reset-btn,\r\n.filter-apply-btn {\r\n  flex: 1;\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.filter-reset-btn {\r\n  background-color: #f5f5f5;\r\n  color: #333;\r\n  border: 1px solid var(--color-border-light);\r\n}\r\n\r\n.filter-reset-btn:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n\r\n.filter-reset-btn:active {\r\n  background-color: #d0d0d0;\r\n}\r\n\r\n.filter-apply-btn {\r\n  background-color: var(--color-primary-green);\r\n  color: var(--color-white);\r\n}\r\n\r\n.filter-apply-btn:hover {\r\n  background-color:var(--color-primary-green);\r\n}\r\n\r\n.filter-apply-btn:active {\r\n  background-color: var(--color-primary-green);\r\n}\r\n\r\n/* Dependency notice for DependentCustomSelectFilter */\r\n.filter-dependency-notice {\r\n  font-size: 11px;\r\n  color: #666;\r\n  padding: 4px 8px;\r\n  background-color: #f0f8ff;\r\n  border-left: 3px solid #007bff;\r\n  border-radius: 3px;\r\n  font-style: italic;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
